import React, {Component} from 'react';
import PropTypes from "prop-types";
import "./style.css";
import Recorder from "./Recorder";

const videoJsOptions = {
  controls: true,
  bigPlayButton: true,
  width: 7680,
  height: 4320,
  fluid: true,
  plugins: {
    record: {
      audio: true,
      video: true,
      maxLength: 300,
      debug: true,
    }
  },
};

class VideoRecorder extends Component {
  static propTypes = {
    uniqueWebKey: PropTypes.any,
    videoId: PropTypes.number,
    campaignVideo: PropTypes.bool,
    onUploadRecordVideo: PropTypes.func,
    onUploadVideoError: PropTypes.func,
  }

  static defaultProps = {
    campaignVideo: false,
  }

  render() {
    const {
      campaignVideo,
      uniqueWebKey,
      videoId,
      onUploadRecordVideo,
      onUploadVideoSuccess,
      onUploadVideoError,
      onCancelRecord,
      contrastColor,
      styleButton,
      onRecordedVideoUploadStart,
      onRecordedVideoUploadEnd
    } = this.props;

    return (
      <React.Fragment>
        <Recorder
          campaignVideo={campaignVideo}
          videoJsOptions={videoJsOptions}
          videoId={videoId}
          uniqueWebKey={uniqueWebKey}
          onUploadRecordVideo={onUploadRecordVideo}
          onUploadVideoSuccess={onUploadVideoSuccess}
          onUploadVideoError={onUploadVideoError}
          onCancelRecord={onCancelRecord}
          contrastColor={contrastColor}
          styleButton={styleButton}
          onRecordedVideoUploadStart={onRecordedVideoUploadStart}
          onRecordedVideoUploadEnd={onRecordedVideoUploadEnd}
        />
      </React.Fragment>
    );
  }
}

export default VideoRecorder;



// WEBPACK FOOTER //
// ./src/components/VideoRecorder/VideoRecorder.js